const APPCONST={}

APPCONST.APP_ROUTE='/TheFarmPost';
APPCONST.PAGE_FITLER='/filter';
APPCONST.PAGE_CONTENT='/content';
APPCONST.PAGE_PILLAR='/pages';

APPCONST.IS_LOCAL=(window.location.hostname==='localhost');
APPCONST.SERVER_URL=APPCONST.IS_LOCAL?'http://localhost:3001':'';
APPCONST.googleAnalyticsCode = 'UA-142278739-1';

APPCONST.WEST=1;
APPCONST.EAST=0;

export default APPCONST;